import { render } from "./ActivityTableModal.vue?vue&type=template&id=209c245c&ts=true"
import script from "./ActivityTableModal.vue?vue&type=script&lang=ts"
export * from "./ActivityTableModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__